<template>
  <v-dialog v-model="openDialog" max-width="500px" persistent>
    <template #activator="activator">
      <slot name="activator" v-bind="activator"></slot>
    </template>
    <v-card>
      <vue-ctk-date-time-picker
        v-model="reserveDatetime"
        :minute-interval="30"
        format="YYYY-MM-DD HH:mm"
        no-button-now
        inline
        :no-button="false"
      />
      <v-card-actions class="d-flex justify-space-between">
        <v-btn color="danger" text @click="openDialog = false"
          >キャンセル</v-btn
        >
        <v-btn color="success" outlined @click='setDateTime'>設定</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker'
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css'

export default {
  name: 'DatePickerDialog',
  components: {
    VueCtkDateTimePicker
  },
  props: {
    value: {
      type: Date,
      required: true
    }
  },
  data () {
    return {
      openDialog: false,
      reserveDatetime: null
    }
  },
  methods: {
    setDateTime () {
      this.$emit('input', this.reserveDatetime)
      this.openDialog = false
    }
  }
}
</script>
